export default __webpack_public_path__ + "static/media/card.3ebf859e.png";